var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    d: "M4,10h40v25H4V10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00796b",
    d: "M41,14v21H7V14 M44,12H4v23h40V12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7c12",
    d: "M42,12v23H6V12H42 M44,10H4v25h40V10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#773d04",
    d: "M46,38v-2c0-1.1-0.9-2-2-2H4c-1.1,0-2,0.9-2,2v2H46z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.2 29.4L19 22.2 12.6 26.8 11.4 25.2 19 19.8 27.8 26.6 36.2 16.4 37.8 17.6zM19 34h-7v-2h7l1 1L19 34z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackboard);
export default __webpack_public_path__ + "static/media/blackboard.ba8465b211a232dd4a7fb8430f2eedef.svg";
export { ForwardRef as ReactComponent };